import React from 'react';
import { FollowOrganizerProps, RemindMeProps } from '../../types';
import { dynaMount } from '../utils/mountComponent';
import RemindMe from './RemindMe';

const REMIND_ME_ROOT_ID = 'listings-root__remind-me';

const RemindMeMount = (
    props: RemindMeProps & FollowOrganizerProps,
): JSX.Element | React.ReactPortal => {
    return dynaMount(
        {
            Component: RemindMe,
            containerId: REMIND_ME_ROOT_ID,
        },
        props,
    );
};

const RemindMeRoot = (
    props: RemindMeProps & FollowOrganizerProps,
): JSX.Element | null => {
    return <RemindMeMount {...props} />;
};

export default RemindMeRoot;
